import React from 'react';

export const InnerLabelTestId = 'innerlabel-input';

type InnerLabelProps = {
  children: string;
  inputName: string;
  hasErrors: boolean;
  showAsPlaceholder?: boolean;
  className?: string;
};

const InnerLabel: React.FC<InnerLabelProps> = ({
  children,
  inputName,
  hasErrors,
  showAsPlaceholder = false,
  className = '',
}: InnerLabelProps) => {
  const sizeAndPosition = showAsPlaceholder ? 'text-md mt-3' : 'text-xs mt-1';
  const classes = `${className} ml-4 ${sizeAndPosition} ${
    hasErrors ? 'input-error-text' : ''
  }`;

  return (
    <label
      htmlFor={inputName}
      className={classes}
      data-testid={InnerLabelTestId}
    >
      {children}
    </label>
  );
};
export default InnerLabel;
